<template>
    <div class="vue-block" :class="{ 'img-opened': imageOpen, '': !imageOpen }">
        <div class="products-slider js-products-slider">
            <div class="container products-slider__container">
                <div class="products-slider__header" v-if="products.length > 0">
                    <h2 class="section-title products-slider__title">
                        You may also like
                    </h2>
                    {{ checkWidth() }}
                    <div
                        :class="{
                            'products-slider__arrows-container': arrowShow,
                            'products-slider__arrows-container--hide': !arrowShow
                        }"
                    >
                        <div
                            class="products-slider__arrow-left products-slider__arrow"
                            @click="PrevSlide"
                        >
                            <SvgIcon
                                class="products-slider__arrow-icon"
                                iconName="ico-arrow-left"
                            />
                        </div>
                        <div
                            class="products-slider__arrow-right products-slider__arrow"
                            @click="NextSlide"
                        >
                            <SvgIcon
                                class="products-slider__arrow-icon"
                                iconName="ico-arrow-right"
                            />
                        </div>
                    </div>
                </div>

                <div
                    class="products-slider__wrapper js-products-slider__wrapper"
                >
                    <Product
                        :products="products"
                        :favorites="favorites"
                        :productWishlist="productWishlist"
                        :wishlist="wishlist"
                        :addToCartLoading="addToCartLoading"
                        :cart="cart"
                        :productId="productId"
                        v-on:addToCompare="addToCompare"
                        @changeImage="changeImage"
                        ref="childProdSlider"
                    />
                </div>
            </div>
        </div>
        <!-- .products -->
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Product from './Parts/Product.vue';
import SvgIcon from '../../base/SvgIcon/SvgIcon.vue';
import AjaxLogin from './../../../../js/site/ajaxLogin';

export default {
    beforeMount() {
        if (typeof window.productId === 'undefined') {
            this.productId = null;
            this.$store.dispatch('getProductSlider', {
                ids: window.sliderTermIds
            });
        } else {
            this.productId = window.productId;
            this.$store.dispatch('getSingleProductSlider', window.productId);
        }
    },
    computed: mapState({
        products: state => state.SliderProduct.products,
        list: state => state.List.list,
        cart: state => state.Cart.cart,
        wishlist: state => state.List.wishlist,
        addToCartLoading: state => state.Cart.addToCartLoading
    }),
    components: {
        Product,
        SvgIcon
    },
    data() {
        return {
            favorites: {},
            productWishlist: {},
            productId: '',
            arrowShow: true,
            compare: [],
            emptyCompare: 3,
            sliderTermIds: window.sliderTermIds,
            compareClass: false,
            kadraGlobal: kadraGlobal,
            imageOpen: false
        };
    },
    watch: {
        products() {
            if (!this.productId) {
                this.$store.dispatch('getList');
            }
            if (!window.cartLoaded) {
                // prevent reloading on each popup at listing page
                this.$store.dispatch('getAllCart');
                window.cartLoaded = true;
            }
        },
        list() {
            this.setFavorites();
        },
        wishlist() {
            this.setProductWishlist();
        }
    },
    methods: {
        changeImage(imageOpen) {
            this.imageOpen = imageOpen;
        },
        compareToggle() {
            this.compareClass = !this.compareClass;
        },
        removeAllFromCompare() {
            this.compareClass = false;
            this.compare = [];
            localStorage.setItem(
                'compare-' + this.kadraGlobal.userId,
                JSON.stringify(this.compare)
            );
            this.$refs.childProdSlider.removeAllCompare();
        },
        addToCompare(compare) {
            if (compare.length === 4) {
                compare.splice(0, 1);
            }
            this.setEmptyCompare(compare);
            this.setCompareToLocalStorage(compare);
            this.compareClass = true;
        },
        setCompareToLocalStorage(compare) {
            localStorage.setItem(
                'compare-' + this.kadraGlobal.userId,
                JSON.stringify(compare)
            );
            this.compare = compare;
        },
        setEmptyCompare(compare) {
            this.emptyCompare = 3 - compare.length;
        },
        removeComper(product) {
            const index = this.compare.findIndex(obj => obj.ID === product.ID);
            this.compare.splice(index, 1);
            localStorage.setItem(
                'compare-' + this.kadraGlobal.userId,
                JSON.stringify(this.compare)
            );
        },
        checkCompare() {
            if (this.compare.length >= 2) {
                window.location.href = kadraGlobal.Url + '/compare';
            }
        },
        setFavorites() {
            const obj = {};
            this.list.forEach(item => {
                if (item.status === 'favorites') {
                    obj[item.product_id] = item;
                }
            });
            this.favorites = obj;
        },
        setProductWishlist() {
            const obj = {};
            if (this.wishlist.length !== 0) {
                this.wishlist.forEach(wish => {
                    obj[wish.ID] = [];
                    this.list.forEach(item => {
                        if (item.status === wish.ID) {
                            obj[wish.ID].push(item.product_id);
                        }
                    });
                });
                this.productWishlist = obj;
            }
        },
        NextSlide() {
            this.$refs.childProdSlider.showNextSlide();
        },
        PrevSlide() {
            this.$refs.childProdSlider.showPrevSlide();
        },
        checkWidth() {
            const slide = document.querySelectorAll('.js-product-info-box');

            if (window.innerWidth > 1349 && slide.length < 5) {
                this.arrowShow = false;
            } else if (window.innerWidth > 991 && slide.length < 4) {
                this.arrowShow = false;
            } else if (window.innerWidth > 767 && slide.length < 3) {
                this.arrowShow = false;
            } else if (window.innerWidth > 520 && slide.length < 2) {
                this.arrowShow = false;
            } else {
                this.arrowShow = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.img-opened {
    z-index: 100000;
}

.vue-block {
    position: relative;
}

.products-slider {
    @include mq(1204px) {
        padding: 93px 0 45px;
    }

    @include mq($lg) {
        padding: 0 0 45px;
    }
}

.products-slider__arrows-container--hide {
    opacity: 0;
    pointer-events: none;
}

.products-slider__container {
    @include mq($lg) {
        // padding-right: 0;
    }

    @include mq($md) {
        padding-right: 15px;
    }

    @include mq(640px) {
        padding: 0 15px;
    }
}
</style>
